// extracted by css-extract-rspack-plugin
export default {"root":"src-wab-client-components-sidebar-tabs-CustomBehaviorsSection-module__root-BgoMDd"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-wab-client-components-sidebar-tabs-CustomBehaviorsSection-module__root-BgoMDd\"}";
        // 1793541995119
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  